import React, { Component, Fragment } from 'react';
import { LocaleProvider } from 'antd';
import en_US from 'antd/lib/locale-provider/en_US';
import { Switch, Route } from 'react-router-dom'
import { createStore, compose, applyMiddleware } from "redux"
import { Provider } from "react-redux"
import createSagaMiddleware from "redux-saga"
import { createBrowserHistory } from 'history'
import { connectRouter, ConnectedRouter, routerMiddleware } from 'connected-react-router'

import Header from './components/Header'
import BodyWrap from './components/BodyWrap'
import FooterWrap from './components/FooterWrap'
import Footer from './components/Footer'
import Home from './views/home'
import Register from './views/register'
import Login from './views/login'
import ForgotPassword from './views/login/forgot_password'
import Search from './views/search'
import NewPassword from './views/login/new_password'
import InnovationsList from './views/innovations'
import InnovationDetails from './views/innovations/details'
import NewsList from './views/News'
import NewsDetails from './views/News/details'
import Webboard from './views/webboard'
import TopicDetails from './views/webboard/details'
import NewTopic from './views/webboard/new_topic'
import EditTopic from './views/webboard/edit_topic'
import Account from './views/account'
import EditProfile from './views/account/edit_profile'
import ChangePassword from './views/account/change_password'
import Contact from './views/contact'

import reducers from "./reducers"
import sagas from "./sagas"
import config from './config'
import withAuthorize from './components/withAuthorize'

const history = createBrowserHistory()

const historyMiddleware = routerMiddleware(history)

const sagaMiddleware = createSagaMiddleware()

let store = createStore(
    connectRouter(history)(reducers),
    applyMiddleware(sagaMiddleware,historyMiddleware)
)

if(!config.production) {
    const composeEnhancers  = typeof window === 'object' 
    && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({}) : compose
    
    const enhancer = composeEnhancers(
        applyMiddleware(sagaMiddleware,historyMiddleware),
    )

    store = createStore(
        connectRouter(history)(reducers),
        enhancer
    )
}

sagaMiddleware.run(sagas)


class Routes extends Component {
    render() {
        return (
            <LocaleProvider locale={en_US}>
                 <Provider store={store}>
                    <ConnectedRouter history={history}>
                    <Fragment>
                        <Header path="/register"/>
                        <BodyWrap>
                            <Switch>
                                <Route exact path="/" component={Home}/>

                                <Route exact path="/register" component={Register}/>
                                <Route exact path="/login" component={Login}/>
                                <Route exact path="/password/forgot" component={ForgotPassword}/>
                                <Route exact path="/password/reset" component={withAuthorize(NewPassword)}/>

                                <Route exact path="/search" component={Search}/>

                                <Route exact path="/innovations" component={InnovationsList}/>
                                <Route exact path="/innovations/:id" component={InnovationDetails}/>

                                <Route exact path="/news" component={NewsList}/>
                                <Route exact path="/news/:id" component={NewsDetails}/>

                                <Route exact path="/webboard" component={withAuthorize(Webboard)}/>
                                <Route exact path="/topic/add" component={withAuthorize(NewTopic)}/>
                                <Route exact path="/topic/:id/edit" component={withAuthorize(EditTopic)}/>
                                <Route exact path="/topic/:id" component={withAuthorize(TopicDetails)}/>

                                <Route exact path="/account" component={withAuthorize(Account)}/>
                                <Route exact path="/profile/edit" component={withAuthorize(EditProfile)}/>
                                <Route exact path="/password/change" component={ChangePassword}/>

                                <Route exact path="/contact" component={Contact}/>
                            </Switch>
                        </BodyWrap>
                        <FooterWrap>
                            <Footer/>
                        </FooterWrap>
                    </Fragment>
                    </ConnectedRouter>
                </Provider>
            </LocaleProvider>
        );
    }
}

export default Routes;
